<div class="container sided actions">
  <div class="container-holder container-one">

    <!-- Classes for a element of action for custom icon size
    [ngClass]="{'small': settings.IconSize == 1, 'medium': settings.IconSize == 2, 'large': settings.IconSize == 3}"
    -->

    @for (action of settings.Actions; track action) {
      <a>
        @if (settings.QuickActionType == 1) {
          <div class="box" [class.has-configured-icon]="settings.Icon || action.Icon">
            @if (settings.Icon || action.Icon) {
              <span class="material-symbols-outlined qa-info-icon"
                [style.color]="getIconColor(settings.Color || action.Color)"
                [style.background-color]="getIconBackgroundColor(settings.BackgroundColor, settings.Color || action.Color)"
                aria-hidden="true">{{settings.Icon || action.Icon}}</span>
            }
            <p class="action-title" [innerHTML]="getActionTitle(action.Title)"></p>
            @if (settings.Description || action.Description) {
              <p class="action-description">{{getActionDescription(settings.Description || action.Description)}}</p>
            }
            <p class="value">{{qaValue}}</p>
            <!--img class="action-loader" *ngIf="!qaValue && qaValue != 0" src="/assets/css/images/platform/loader.gif" /-->
            @if (!qaValue && qaValue != 0) {
              <sem-loader class="sided-50" [showLoader]="true"></sem-loader>
            }
          </div>
        }
        @if (settings.QuickActionType == 2) {
          <div class="box qa-shortcut" (click)="navigate(settings.Actions[0].Url)">
            <p class="action-type">{{translationsService.translate('WebGalis_Module_GalisWeb_Shortcut')}}</p>
            <p class="action-title" [innerHTML]="translationsService.translate(action.Title)"></p>
            <img src="/assets/css/images/platform/shortcut-arrow@2x.png" />
          </div>
        }
        @if (settings.QuickActionType == 3) {
          <div class="box custom-action-onclick" (click)="actionClick(action.Url, action)">
            <p class="action-title" [innerHTML]="getActionTitle(action.Title)"></p>
            <img src="/assets/css/images/platform/shortcut-arrow@2x.png" />
            <sem-loader class="sided-50" [showLoader]="showLoaderAction"></sem-loader>
          </div>
        }
      </a>
      }<!--
      -->


    </div>
  </div>
